import { CasChip, CasStackRow } from 'src/compass/shared/components';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';
import getCasTableCellValue from 'src/compass/shared/components/CasTable/getCasTableCellValue';
import ICasRenderCellProps from 'src/compass/shared/components/CasTable/ICasRenderCellProps';

interface IProps extends ICasRenderCellProps {
  onClick?: (id: number) => void;
}

export function RenderRiskManagerName({ row, column, onClick }: IProps) {
  const value = getCasTableCellValue({ row, column });
  const { otherRiskManagerNames, id } = row || {};
  return (
    <CasStackRow alignItems="center">
      {onClick ? <CasLink onClick={() => onClick(id)}>{value}</CasLink> : value}
      {otherRiskManagerNames?.map((riskManager: string) => (
        <CasChip key={riskManager} label={riskManager} color="disabled" size="small" />
      ))}
    </CasStackRow>
  );
}
